var exports = {
  "Q": "xa15a2ab7--1b9476--phones",
};

module.exports = exports;
